"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingPaymentStatus = exports.ReepayCardTypes = exports.ReepayPaymentTypes = exports.MobilePeoplePaymentTypes = exports.FarpayPaymentTypes = exports.PaymentMethodStatus = exports.getProviderUrlParam = exports.Providers = void 0;
var Providers;
(function (Providers) {
    Providers["MANUAL"] = "MANUAL";
    Providers["REEPAY"] = "REEPAY";
    Providers["YOURPAY"] = "YOURPAY";
    Providers["PAYLIKE"] = "PAYLIKE";
    Providers["FARPAY"] = "FARPAY";
    Providers["MOBILE_PEOPLE"] = "MOBILE_PEOPLE";
})(Providers || (exports.Providers = Providers = {}));
var ProvidersUrlParam;
(function (ProvidersUrlParam) {
    ProvidersUrlParam['mobile-people'] = "MOBILE_PEOPLE";
    ProvidersUrlParam['farpay'] = "FARPAY";
    ProvidersUrlParam['reepay'] = "REEPAY";
})(ProvidersUrlParam || (ProvidersUrlParam = {}));
const getProviderUrlParam = (provider) => {
    return (ProvidersUrlParam[provider] || provider);
};
exports.getProviderUrlParam = getProviderUrlParam;
var PaymentMethodStatus;
(function (PaymentMethodStatus) {
    PaymentMethodStatus["CREATED"] = "CREATED";
    PaymentMethodStatus["SAVED"] = "SAVED";
    PaymentMethodStatus["DELETED"] = "DELETED";
})(PaymentMethodStatus || (exports.PaymentMethodStatus = PaymentMethodStatus = {}));
var FarpayPaymentTypes;
(function (FarpayPaymentTypes) {
    FarpayPaymentTypes["BETALINGSSERVICE"] = "BS";
    FarpayPaymentTypes["LEVERANDORSERVICE"] = "LS";
    FarpayPaymentTypes["DANKORT"] = "Dankort";
    FarpayPaymentTypes["VISA"] = "Visa";
    FarpayPaymentTypes["MASTERCARD"] = "MasterCard";
    FarpayPaymentTypes["MOBILEPAYSUBSCRIPTION"] = "MobilePaySubscriptions";
    FarpayPaymentTypes["MOBILEPAYINVOICE"] = "MobilePayInvoice";
})(FarpayPaymentTypes || (exports.FarpayPaymentTypes = FarpayPaymentTypes = {}));
var MobilePeoplePaymentTypes;
(function (MobilePeoplePaymentTypes) {
    MobilePeoplePaymentTypes["VISA"] = "Visa";
    MobilePeoplePaymentTypes["MASTERCARD"] = "MasterCard";
    MobilePeoplePaymentTypes["MOBILEPAY"] = "MobilePay";
    MobilePeoplePaymentTypes["DANKORT"] = "Dankort";
})(MobilePeoplePaymentTypes || (exports.MobilePeoplePaymentTypes = MobilePeoplePaymentTypes = {}));
var ReepayPaymentTypes;
(function (ReepayPaymentTypes) {
    ReepayPaymentTypes["Mastercard"] = "mc";
    ReepayPaymentTypes["Visa"] = "visa";
    ReepayPaymentTypes["VisaElectron"] = "visa_elec";
    ReepayPaymentTypes["Dankort"] = "dankort";
    ReepayPaymentTypes["Vipps"] = "vipps";
    ReepayPaymentTypes["Swish"] = "swish";
})(ReepayPaymentTypes || (exports.ReepayPaymentTypes = ReepayPaymentTypes = {}));
var ReepayCardTypes;
(function (ReepayCardTypes) {
    ReepayCardTypes["Mastercard"] = "mc";
    ReepayCardTypes["Visa"] = "visa";
    ReepayCardTypes["VisaDankort"] = "visa_dk";
    ReepayCardTypes["VisaElectron"] = "visa_elec";
    ReepayCardTypes["Dankort"] = "dankort";
})(ReepayCardTypes || (exports.ReepayCardTypes = ReepayCardTypes = {}));
var PendingPaymentStatus;
(function (PendingPaymentStatus) {
    PendingPaymentStatus["PENDING"] = "PENDING";
    PendingPaymentStatus["APPROVED"] = "APPROVED";
    PendingPaymentStatus["REJECTED"] = "REJECTED";
})(PendingPaymentStatus || (exports.PendingPaymentStatus = PendingPaymentStatus = {}));
//# sourceMappingURL=index.js.map